import {
  TVariableDetailRow,
  TPatientSourceRowToArchive,
  TPatientSourceRowToEdit,
  TSourceManagementEntityName,
  TSourceManagementVariables,
  TPatientSourceToCreate,
  TPatientSourceToUpdate,
} from '../type/source-management'
import { customErrorResponse } from '../utility/custom-error-response'
import { request, resetCustomOnResponseError, setCustomOnResponseError } from './axios'

export const PatientSource = {
  getConfig: async (): Promise<TSourceManagementVariables> => {
    const typeParam = 'logic=Patient_Source'
    const {
      data: { configs },
    } = await request({
      url: `/category-classification/logic-mapping/configuration/?${typeParam}`,
    })

    return {
      configs,
    }
  },

  getVariableDetails: async (
    sourceName: string,
    type: string,
    search_key?: string,
    includeTerminated = false,
  ): Promise<{ variable_details: TVariableDetailRow[] }> => {
    setCustomOnResponseError(customErrorResponse)
    try {
      const searchParam = search_key ? `&search=${search_key}` : ''
      const typeParam = '&logic=Patient_Source'

      const {
        data: { variable_details },
      } = await request({
        url: `/category-classification/logic-mapping/management/variable/?include_terminated=${includeTerminated}&type=${type}&category=${sourceName}${searchParam}${typeParam}`,
      })
      return {
        variable_details,
      }
    } finally {
      resetCustomOnResponseError()
    }
  },

  getNameById: async (variable: string, entity_id: string): Promise<TSourceManagementEntityName> => {
    const {
      data: { entity_name },
    } = await request({
      url: `/category-classification/logic-mapping/management/entity-meta/?type=${variable}&id=${entity_id}`,
    })
    return {
      entity_name,
    }
  },

  updatePatientSource: async (payloadToUpdate: TPatientSourceToUpdate) => {
    setCustomOnResponseError(customErrorResponse)
    return request({
      method: 'patch',
      url: '/category-classification/logic-mapping/management/',
      data: {
        ...payloadToUpdate,
      },
    }).finally(() => {
      resetCustomOnResponseError()
    })
  },

  createPatientSource: async (payloadToCreate: TPatientSourceToCreate) => {
    setCustomOnResponseError(customErrorResponse)
    return request({
      method: 'post',
      url: '/category-classification/logic-mapping/management/',
      data: {
        ...payloadToCreate,
      },
    }).finally(() => {
      resetCustomOnResponseError()
    })
  },

  updateRow: async (row: TPatientSourceRowToEdit) => {
    const typeParam = 'logic=Patient_Source'
    setCustomOnResponseError(customErrorResponse)
    return request({
      method: 'patch',
      url: `/category-classification/logic-mapping/management/row/?${typeParam}`,
      data: {
        ...row,
      },
    }).finally(() => {
      resetCustomOnResponseError()
    })
  },
  removeRow: async (payloadToRemove: TPatientSourceRowToArchive) => {
    const typeParam = '&logic=Patient_Source'
    setCustomOnResponseError(customErrorResponse)
    const { effective_start_date, id, type, category } = payloadToRemove

    return request({
      method: 'delete',
      url: `/category-classification/logic-mapping/management/row/?category=${category}&type=${type}&id=${id}&effective_start_date=${effective_start_date}${typeParam}`,
    }).finally(() => {
      resetCustomOnResponseError()
    })
  },
  removeVariable: async (variable: string, source_name: string) => {
    const typeParam = '&logic=Patient_Source'
    setCustomOnResponseError(customErrorResponse)
    return request({
      method: 'delete',
      url: `/category-classification/logic-mapping/management/variable/?category=${source_name}&type=${variable}${typeParam}`,
    }).finally(() => {
      resetCustomOnResponseError()
    })
  },
}
